<h2 mat-dialog-title>Mini-match Settings</h2>

<mat-dialog-content>
  <div class="settings-section">
    <h3>Select groups to set inactive: Not included in mini-match</h3>

    <div class="option-group crossover-group">
      <mat-checkbox
        [(ngModel)]="allCrossoverParticipants"
        [disabled]="isProcessing">
        Crossover participants
      </mat-checkbox>
    </div>

    <div class="option-group pm-waitlist">
      <div class="pm-header">
        <label>PM waitlist participants:</label>
      </div>

      <div *ngIf="isLoadingCenters" class="loading-centers">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading centers...</span>
      </div>

      <div *ngIf="!isLoadingCenters" class="pm-groups">
        <mat-checkbox
          *ngFor="let group of pmWaitlistGroups"
          [(ngModel)]="group.checked"
          [disabled]="isProcessing">
          {{ group.label }}
        </mat-checkbox>
        <mat-checkbox
          [checked]="allPMGroupsChecked"
          [indeterminate]="somePMGroupsChecked"
          (change)="toggleAllPMGroups()"
          [disabled]="isProcessing">
          Select all
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="toggle-section" *ngIf="data.hasMinimatchInactive">
    <button
      mat-raised-button
      (click)="toggleAllInactiveToActive()"
      [disabled]="isTogglingActive || isProcessing">
      <mat-icon *ngIf="!isTogglingActive">playlist_add</mat-icon>
      <mat-spinner *ngIf="isTogglingActive" diameter="20"></mat-spinner>
      Toggle: all current 'inactive: Not included in mini-match' participants to 'active'
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="cancel()"
    [disabled]="isProcessing || isTogglingActive">
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="applySettings()"
    [disabled]="isProcessing || isTogglingActive || isLoadingCenters || !hasSelections">
    <mat-spinner *ngIf="isProcessing" diameter="20"></mat-spinner>
    <span *ngIf="!isProcessing">Apply</span>
  </button>
</mat-dialog-actions>
